import clsx from 'clsx';
import React from 'react';

import { friendlyPulumiError } from '@/utils/friendlyPulumiError';

import styles from './friendlyError.module.scss';

export interface FriendlyErrorProps {
  error?: string | null;
  className?: string;
}

export function FriendlyError( { error, className }: FriendlyErrorProps ) {
  if ( !error ) return null;
  const friendly = friendlyPulumiError( error );

  if ( friendly ) {
    return (
      <div className={ clsx( styles.friendly, className ) }>
        <div className={ styles.title }>{ friendly.title }</div>
        <div className={ styles.description }>{ friendly.description }</div>
        <details className={ styles.details }>
          <summary>Show full error log</summary>
          <pre className={ styles.raw }>{ friendly.raw }</pre>
        </details>
      </div>
    );
  }

  return <pre className={ clsx( styles.raw, className ) }>{ error }</pre>;
}
